    <div class="modal-container">
      <div class="modal-header border-0 justify-content-start">
        <h1 class="modal-title text-center text-primary-color">Assign Mailing List</h1>
      </div>
      <div class="modal-body">
        <div class="mb-4">
            <app-dropdown
                [selectLabel]="'Mailing List'"
                [data]="mailingListDropdown"
                [selectValue]="mailingLists.mailingListId"
                (selectValueEmit)="mailingLists.mailingListId = $event" 
                [optionDisable]="mailingLists.mailingListId"
                [required]="false"
                (click)="clearValue()">
            </app-dropdown>
        </div>
        <div class="mb-4 d-flex justify-content-center">
            <span class="text-light-gray mobile-view-primary-text">OR</span>
        </div>
        <div class="mb-3">
            <app-checkbox
            [lableClass]="'text-gray '"
            (check)="mailingLists.isCreated = !mailingLists.isCreated;checkedValue($event);clearDropdown()"
            [status]="mailingLists?.isCreated"
            [(ngModel)]="mailingLists.isCreated"
            [lableName]="'Create New Mailing List'"
            [dyanamicId]="'createNewMsilingList'"
          >
          </app-checkbox>

        </div>
        <div class="">
            <app-input 
            [inputLabel]="'Mailing List'" 
            [inputType]="'text'" 
            [inputValue]="mailingLists?.mailingListName"
            (inputValueEmit)="mailingLists.mailingListName=$event"
            [isInputDisabled]='!mailingLists?.isCreated'
            [ngClass]="{'border-red': !mailingLists.mailingListName && submit && mailingLists?.isCreated }" 
            (click)="clearDropdown()" >
        </app-input>

        </div>

      </div>
      <div class="modal-footer border-0 justify-content-center">
        <div class="m-0 d-flex gap-3">
          <app-button 
            [buttonType]="'button'"  
            [button_2]="true" 
            [buttonClass]="'button popup-button button-info'" 
            (click)="activeModal.close()" 
            [buttonLable]="enumButtonName.CANCEL">
          </app-button>
          <app-button 
            [buttonType]="'submit'"  
            [button_2]="true"  
            [buttonClass]="'button popup-button' + (mailingLists.mailingListId || mailingLists.mailingListName || mailingLists.isCreated ? ' button-primary' : ' dark-info') " 
            (click)="applyChanges()" 
            [buttonLable]="enumButtonName.APPLY">
        </app-button>
       
      </div>
    </div>
    